import collapse from '@alpinejs/collapse'
import Alpine from 'alpinejs'
import Cookies from 'js-cookie'
import accordionItem from './components/accordionItem'
import ajaxForm from './components/ajaxForm'
import carousel from './components/carousel'

window.cookies = Cookies

window.Alpine = Alpine
window.Alpine.plugin(collapse)

window.Alpine.data('accordionItem', accordionItem)
window.Alpine.data('ajaxForm', ajaxForm)
window.Alpine.data('carousel', carousel)

Alpine.start()
